import React from "react";
import { Route } from "react-router-dom";
import { useStore } from "src/store/Store";

const PrivateRoute = ({ component: Component, modules, ...rest }) => {
  const userRole = sessionStorage.getItem("userRole");
  if (modules.find((module) => module === userRole)) {
    return (
      <Route
        {...rest}
        exact
        key={rest?.path}
        render={(props) => <Component {...props} />}
      />
    );
  }
  else return (<></>);
};

export default PrivateRoute;
